import { gql } from '@lcs/shared/api';

export const deleteExtensionGroupMutation = gql`
   mutation DeleteExtensionGroup($extensionGroupId: UInt!) {
      deleteExtensionGroup(id: $extensionGroupId)
   }
`;
